module.exports = __webpack_public_path__ + "img/70.3b00d223.png";